const { VUE_APP_MIXPANEL_TOKEN, PROD } = import.meta.env || {};

export const settings = {
  token: VUE_APP_MIXPANEL_TOKEN,
  disabled: !PROD,
};
